/*
* Report page
*/

import * as React from 'react';
import * as _ from 'lodash';

import * as ReportComponents from '../report-components';

export const Render = ({ registerFunc, refFunc, scrollToFunc, pageTitle = '', className = '', pageCount, reportData, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.introduction;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageHeaderFooter, sectionName, registerFunc, refFunc, scrollToFunc);

    const { currentOrderUsers } = reportData;

    // PREPARER'S CREDENTIALS (NOTE: BINDS TO HTML FROM DATABASE!)
    let resumeHtml = _.get(currentOrderUsers, 'manager.resume', '');
    resumeHtml = resumeHtml.replace(/style="[^"]*"/g, '');

    const credentials = (resumeHtml) ? (
        <ReportComponents.ParagraphSection title="Preparer's Credentials" body="">
            <div className="preparers-credentials" dangerouslySetInnerHTML={{ __html: resumeHtml }} />
        </ReportComponents.ParagraphSection>
    ) : (<div />);

    return (
        <div>
            <ReportPageWithRegister pageIndex={0} title={pageTitle} className={className} totalPageCount={pageCount} showFooter={true} footerData={reportData}>
                <ReportComponents.ParagraphSection title="Reserve Study Purpose" body="">
                    <div>
                        The purpose of this Reserve Study is to provide the board with a budgeting tool to help ensure that there are adequate
                        reserve funds available to perform future reserve projects. In this respect our estimates of the current and future Fully
                        Funded balances are less significant than the recommended reserve contribution. The board should weigh carefully our
                        recommendations when setting the Reserve Contribution. The detailed schedules will serve as an advanced warning
                        that major projects will need to be addressed in the future. This will allow the Board of Directors to have ample time to
                        obtain competitive estimates and bids that will result in cost savings to the individual homeowners. It will also ensure the
                        physical well-being of the property and ultimately enhance each owner's investment, while limiting the possibility of
                        unexpected major projects that may lead to special assessments.
                    </div>
                </ReportComponents.ParagraphSection>

                {credentials}

                <ReportComponents.ParagraphSection title="Budget Breakdown" body="">
                    <div>
                        Every association conducts their business within a budget. There are typically two main parts to this budget, the
                        Operating budget and the Reserve budget. The operating budget typically includes all expenses that occur on an annual
                        basis as well as general maintenance and repairs. Typical Operating budget line items include management fees,
                        maintenance expenses, utilities, etc. The reserves are primarily made up of capital replacement items such as roofing,
                        fencing, mechanical equipment, etc., that do not normally occur on an annual basis. Typically, the reserve contribution
                        makes up 15% - 40% of the association's total budget. Therefore, reserves are considered to be a major part of the
                        overall monthly association assessment.
                    </div>
                </ReportComponents.ParagraphSection>

                <ReportComponents.ParagraphSection title="Report Sections" body="">
                    <div>
                        <div className="pdf-paragraph-section">The <i><strong>Reserve Analysis</strong> Section</i> contains the evaluation of the association's reserve balance, income, and expenses. It
                            includes a finding of the client's current reserve fund status (measured as percent funded) and a recommendation for an
                            appropriate reserve allocation rate (also known as the funding plan).
                        </div>

                        <div>The <i><strong>Component Evaluation</strong> Section</i> contains information regarding the physical status and replacement cost of major
                            common area components the association is responsible to maintain. It is important to understand that while the
                            component inventory will remain relatively “stable” from year to year, the condition assessment and life estimates will
                            most likely vary from year to year.</div>
                    </div>
                </ReportComponents.ParagraphSection>
            </ReportPageWithRegister>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-introduction.tsx